export default __webpack_public_path__ + "static/media/17.6daa20d5.webp";